export var TransportItemType;
(function (TransportItemType) {
    TransportItemType["EXCEPTION"] = "exception";
    TransportItemType["LOG"] = "log";
    TransportItemType["MEASUREMENT"] = "measurement";
    TransportItemType["TRACE"] = "trace";
})(TransportItemType || (TransportItemType = {}));
//# sourceMappingURL=types.js.map